import React from 'react';

const ResizeHandle = ({ onMouseDown }) => {
  return (
    <div
      style={{
        width: 6,
        cursor: 'col-resize',
        background: '#ccc',
        zIndex: 1,
      }}
      onMouseDown={onMouseDown}
    />
  );
};

export default ResizeHandle;
